// frontend/src/features/workspace/api/use-dashboard.ts
import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { useApi } from '@/hooks/useAppApi'

export interface DashboardResponse {
  recentModels: Array<{
    id: string
    projectId: string
    projectName: string
    name: string
    sourceType: string
    pipeCount: number
    calcStatus: string
    calcSummary: { iterations?: number; warningsCount?: number } | null
    updatedAt: string
  }>
  stats: {
    totalModels: number
    totalPipes: number
    convergedCount: number
    needsAttentionCount: number
  }
  projects: Array<{
    id: string
    name: string
    modelCount: number
  }>
  recentImports: Array<{
    id: string
    sourceType: string
    originalFileName: string | null
    pipeCount: number | null
    createdAt: string
    modelId: string | null
    projectId: string | null
  }>
}

export function useDashboard(): UseQueryResult<DashboardResponse> {
  const api = useApi()

  return useQuery<DashboardResponse>({
    queryKey: ['dashboard'],
    queryFn: (): Promise<DashboardResponse> => api.get<DashboardResponse>('/dashboard'),
    staleTime: 30_000, // 30 seconds — avoids rapid refetches while on the page
    refetchOnMount: 'always', // always refetch when navigating back to dashboard
  })
}
